import React, { Component } from "react";
import { Dropdown } from 'primereact/dropdown';
import axios from "axios";
import {config} from "../shared/config";
import * as util from '../shared/commons';

export default class CourseCombo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items:[],
            loading:true
        }
    }
    componentDidMount = ()=>{
        this.reloadItems();
    }
    reloadItems = () =>{
      var params = {login:util.getTrustedUser(), degree:this.props.degree, fieldId:this.props.fieldId, lastIndex:0, pageSize:0};
      var url = config.Server+`/basic/course/list`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  

                var items = [];
                for(var i=0;i<response.length;i++){
                    if(this.props.returnFullItem === true){
                        var r = {"id":response[i].id, "OptionTitle":"["+response[i]["code"]+"] " +response[i]["name"], "OptionValue":response[i]["id"], itemValue:response[i]};
                        items.push(r);
                    }
                    else{
                        items.push({"id":response[i].id, "OptionTitle":"["+response[i]["code"]+"] " +response[i]["name"], "OptionValue":response[i]["id"]});
                    }            
                } 
                var newState = {...this.state};

                newState["loading"] = false;

                newState["items"] = items;

                this.setState(newState);                 
                  
              }
              else{
                  
              }
          })
          .catch(error => {
              
          });
    } 
    onInputChange = (e) => {
        var val = e;
        if(val){ 
            if(this.props.returnFullItem === true){
                this.props.onChange(val);           
            }
            else{
                this.props.onChange(val.OptionValue);           
            }            
        }
        else{
            if(this.props.returnFullItem === true){
                this.props.onChange({});           
            }
            else{
                this.props.onChange("");
            }            
        }
    }
    getItemIndex = (items, value) =>{
        if(value == null)return -1;
        if(!value.id)return -1;
        if(value.id == null)return -1;
        if(items === null) return -1;
        if(items.length === 0) return -1;
        for(var i=0;i<items.length;i++){
            if(this.props.returnFullItem === true){
                if(items[i].id === value.id) return i;
            }
            else{
                if(items[i].OptionValue === value) return i;
            }            
        }
        return -1;
    }

    render() { 
        var ind = this.getItemIndex(this.state.items, this.props.value);
        var ci = null;
        if(ind >=0) ci = this.state.items[ind];
        var visible = true;
        if(this.props.visible === false)
                visible = false;
        var display = "block";
        if(!visible) display = "none";

        return (
            <>
                <div className="field" style={{display:display}}>
                    <label className="font-bold" style={{width:"100%"}}>
                        درس
                    </label>
                    <Dropdown scrollHeight="350px" disabled={this.props.disabled} value={ci} onChange={(e) => this.onInputChange(e.value)} options={this.state.items} optionLabel="OptionTitle"
                        placeholder={"درس را انتخاب کنید"} className="w-full" checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={this.state.loading}/>
                </div>
            </>
        );
    }
}
 
